import { mapActions } from 'vuex'

export default {
    data () {
        return {
            default: ""
        }
    },
    methods: {
        ...mapActions({
            viewShortSpinShow:'view/shortSpinShow',
            viewShortSpinHide:'view/shortSpinHide',
            addError:'error/addError',
            clearError:'error/clearError',
            searchSearchCogen:'search/searchCogen',
            searchSearchHybridWaterHeater:'search/searchHybridWaterHeater',
            searchSearchElectricHeatPump:'search/searchElectricHeatPump',
        }),
        searchCogen(type, filter){
            //計算以外の処理でのローディングスピンを表示
            this.viewShortSpinShow()
            this.clearError()
            return this.searchSearchCogen({"type":type, "filter":filter})
                .then(response => {
                    //計算以外の処理でのローディングスピンを非表示にする
                    this.viewShortSpinHide()
                    return response.data
                }, () => {
                    //計算以外の処理でのローディングスピンを非表示にする
                    this.viewShortSpinHide()
                    this.addError('機器の取得に失敗しました')
                })
        },
        searchHybridWaterHeater(filter){
            //計算以外の処理でのローディングスピンを表示
            this.viewShortSpinShow()
            this.clearError()
            return this.searchSearchHybridWaterHeater({filter})
                .then(response => {
                    //計算以外の処理でのローディングスピンを非表示にする
                    this.viewShortSpinHide()
                    return response.data
                }, () => {
                    //計算以外の処理でのローディングスピンを非表示にする
                    this.viewShortSpinHide()
                    this.addError('機器の取得に失敗しました')
                })
        },
        searchElectricHeatPump(filter){
            //計算以外の処理でのローディングスピンを表示
            this.viewShortSpinShow()
            this.clearError()
            return this.searchSearchElectricHeatPump({filter})
                .then(response => {
                    //計算以外の処理でのローディングスピンを非表示にする
                    this.viewShortSpinHide()
                    return response.data
                }, () => {
                    //計算以外の処理でのローディングスピンを非表示にする
                    this.viewShortSpinHide()
                    this.addError('機器の取得に失敗しました')
                })
        },
    }
}